/*
 * $Id:: AccountTypeCard.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Card from '../../../../components/Card';
import { t } from '../../../../providers';

const useStyles = makeStyles((theme) => ({
    fieldLabel: {
        color: theme.palette.text.label,
        fontSize: '0.625rem',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: 'normal',
    },
    fieldValue: {
        color: theme.palette.text.value,
        fontSize: '0.75rem',
        letterSpacing: 'normal',
        marginBottom: '10px',
    },
}));

const AccountTypeCard = ({ initialValues }) => {
    const classes = useStyles();
    const isRepresentative = initialValues.personType === 'Representative';
    const accountTypeLabel = isRepresentative ? 'type.representative' : 'type.applicant';
    const legalStatus = isRepresentative ? initialValues.legalStatus : initialValues.accountType;
    return (
        <Card title={'user.account.type.title'} canEdit={false} cardId={'profile_account_type_card'}>
            <Typography className={classes.fieldLabel}>{t('account.type')}</Typography>
            <Typography className={classes.fieldValue}>{(initialValues && initialValues.personType) || '-'}</Typography>
            <Typography className={classes.fieldLabel}>{t(accountTypeLabel)}</Typography>
            <Typography className={classes.fieldValue}>{(initialValues && initialValues.accountType) || '-'}</Typography>
            {isRepresentative && (
                <>
                    <Typography className={classes.fieldLabel}>{t('legal.status')}</Typography>
                    <Typography className={classes.fieldValue}>{legalStatus || '-'}</Typography>
                </>
            )}
        </Card>
    );
};

export default AccountTypeCard;
